import store from '@stores';
import Promise from '@services/Promise';

export default class {
  submitting = false;
  submitted = false;
  constructor(ref, data = {}) {
    this.setValidator(ref);
    this.init(data);
    this.setPromise();
    this.$store = store;
  }

  setPromise() {
    this.postPromise = Promise.postPromise;
    this.getPromise = Promise.getPromise;
    this.patchPromise = Promise.patchPromise;
    this.deletePromise = Promise.deletePromise;
  }

  setValidator(ref) {
    if (!this.$validator) {
      const interval = setInterval(() => {
        if (ref && ref.validator) {
          this.$validator = ref.validator;
          clearInterval(interval);
        }
      }, 200);
    }
  }

  init(data, defaultData = {}) {
    data = Object.assign({}, defaultData, data);
    this.originalData = data;
    for (let field in data) {
      this[field] = data[field];
    }
    this.submitting = false;
    this.submitted = false;
  }

  reinit(data) {
    this.submitted = false;
    for (let field in this.originalData) {
      this[field] = data[field];
    }
  }

  set(key, value) {
    this.originalData[key] = value;
    this[key] = value;
    if (this.$set) {
      this.$set(this, key, value);
    }
  }

  /**
   * Fetch all relevant data for the form.
   */
  data() {
    let data = {};

    for (let property in this.originalData) {
      data[property] = this[property];
    }

    return data;
  }

  /**
   * Reset the form fields.
   */
  reset(data = {}) {
    this.reinit(Object.assign({}, this.originalData, data));
    this.$validator && this.$validator.reset();
  }

  /**
   * Submit the form.
   */
  beforeSubmit() {
    this.submitting = true;
  }

  afterSubmit() {
    this.submitting = false;
    if (this.submitted === 0) {
      this.submitted = false;
    } else {
      this.submitted = true;
    }
  }

  getScopeName() {
    return null;
  }

  validate(scope = null) {
    return !this.submitting && this.$validator.validate();
  }

  displayValidation(validationErrors) {
    let firsterror = true;
    for (let field in this.originalData) {
      if (validationErrors.hasOwnProperty(field)) {
        if (firsterror) {
          firsterror = false;
          let el = document.querySelector(`[name='${field}'`);
          el = el ? el : document.querySelector(`[data-vv-as='${field}'`);
          if (el) {
            el.scrollIntoView({ behavior: 'instant' });
            el.focus();
          }
        }
      }
    }
    this.$validator.$emit('handle');
  }

  handleFields(validationErrors) {
    for (let field in validationErrors) {
      if (validationErrors.hasOwnProperty(field)) {
        let err = validationErrors[field];
        err = err.map((er) =>
          er.replace(field, field.replace(/\./g, ' ').replace(/_/g, ' '))
        );
        delete validationErrors[field];
        field = field.replace(/\./g, '_');
        if (!this.$validator.fields[field] && field.indexOf('_') > -1) {
          let newField = field.split('_');
          let flag = true;
          while (flag) {
            newField.splice(newField.length - 1, 1);
            let newName = newField.join('_');
            if (this.$validator.fields[newName]) {
              if (!validationErrors[newName]) {
                field = newName;
                flag = false;
              } else {
                flag = false;
              }
            }
            if (newField.length <= 1) {
              flag = false;
            }
          }
        }
        if (this.$validator.fields[field]) {
          validationErrors[field] = err;
        }
      }
    }
    return validationErrors;
  }

  async handleValidation(validationErrors) {
    validationErrors = this.handleFields(validationErrors);
    await this.$validator.setErrors(validationErrors);
    this.displayValidation(validationErrors);
  }
  handleError(error, toastID = 'validation-toast') {
    this.submitted = 0;
    if (!error.response) {
      console.error(error);
      return;
    }
    if (error.response.status === 422) {
      $showError(error.response.data.message, toastID);
      let validationErrors = error.response.data.errors;
      this.handleValidation(validationErrors);
    } else {
      let message = error.response.message
        ? error.response.message
        : error.response.data.message;
      let option = {
        id: toastID,
      };
      let length = 200;
      if (message.length > length) {
        option.layout = 2;
      }
      $showError(message, 'Error', option);
    }
  }
}
